import { jsx as p, Fragment as I } from "react/jsx-runtime";
import { c as h } from "react/compiler-runtime";
import { useState as C, useEffect as F } from "react";
const N = (o) => {
  if (!o) return 0;
  const t = o.toString(), n = t.indexOf(".");
  return n === -1 ? 0 : t.length - n - 1;
};
function j(o) {
  const t = h(9), {
    duration: n,
    value: e
  } = o, i = n === void 0 ? 1500 : n;
  let s;
  t[0] !== e ? (s = N(e), t[0] = e, t[1] = s) : s = t[1];
  const c = s, [a, m] = C(0);
  let l, u;
  t[2] !== c || t[3] !== i || t[4] !== e ? (l = () => {
    let r = 0;
    const d = e, x = e / 20;
    if (r === d)
      return;
    if (e < 10) {
      m(e);
      return;
    }
    const g = i / 20, v = setInterval(() => {
      r = r + x, m(Number(r.toFixed(c))), r >= d && (m(d), clearInterval(v));
    }, g);
    return () => clearInterval(v);
  }, u = [e, i, c], t[2] = c, t[3] = i, t[4] = e, t[5] = l, t[6] = u) : (l = t[5], u = t[6]), F(l, u);
  let f;
  return t[7] !== a ? (f = /* @__PURE__ */ p(I, { children: a }), t[7] = a, t[8] = f) : f = t[8], f;
}
export {
  j as AnimationCounter
};
